import gql from "graphql-tag";

const imageFields = `id
alternativeText
url
formats`;

export const GET_BLOG_DATA = gql`
  query GET_BLOG_DATA($limit: Int, $tag: String, $start: Int, $countryCode: String) {
    postsConnection(where: { countries: { twoLetterCode: $countryCode }, published: true, filterTags: { tag: $tag } }) {
      aggregate {
        count
      }
    }
    posts (
      where: { countries: { twoLetterCode: $countryCode }, published: true, filterTags: { tag: $tag } }
      sort: "publicationDate:desc"
      limit: $limit,
      start: $start
    ) {
      id
      title
      slug
      publicationDate
      meta{
        id
        seo{
          id
          description
          keywords
          thumbnail{
            ${imageFields}
          }
        }
      }
      header {
        id
        h1
        author
        heroImage {
          ${imageFields}
        }
        content
      }
      filterTags {
        id
        tag
      }
      nextPost {
        id
        publicationDate
        slug
        header {
          h1
          heroImage {
            ${imageFields}
          }
        }
        meta{
          id
          seo{
            id
            description
            keywords
            thumbnail{
              ${imageFields}
            }
          }
        }
      }
      blogContent {
        __typename
        ... on ComponentBlogTextBlock {
          id
          richText
        }
        ... on ComponentBlogTextImage {
          id
          Content
          Image {
            ${imageFields}
          }
        }
        ... on ComponentBlogTwoColumns {
          id
          left
          right
        }
        ... on ComponentBlogImageText {
          id
          Image {
            ${imageFields}
          }
          Content
        }
        ... on ComponentBlogReactComponent {
          id
          name
        }
        ... on ComponentBlogWideImage {
          id
          imageWide {
            ${imageFields}
          }
        }
        ... on ComponentBlogVideo {
          id
          title
          video_text
          video {
            url
          }
        }
        ... on ComponentBlogCaption {
          id
          caption
        }
         ... on ComponentBlogMiniCta{
          header
          booknow
          booknowlink
          downloadappcaption
          downloadapplink
        }
      }
    }
  }
`;
